import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, switchMap } from 'rxjs';
import { ApplicationDataService } from './application-data.service';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  public userCode = sessionStorage.getItem('user_code');
  public userToken: any = sessionStorage.getItem('token');

  constructor(private httpClient: HttpClient, private applicationDataService: ApplicationDataService) { }

  public postAPI(url: any, payload?: any, queryParam?: any) {
    return this.applicationDataService.initEnvironments().pipe(
      switchMap(env =>
        this.httpClient.post(env.APIcalling + url + 'v1' + (queryParam ? queryParam : ''), payload))
    );
  }

  public getAPI(url: any, queryParam?: any) {
    return this.applicationDataService.initEnvironments().pipe(
      switchMap(env =>
        this.httpClient.get(env.APIcalling + url + 'v1' + (queryParam ? queryParam : '')))
    );
  }

}
